import React from 'react';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Button from '@/components/Button';
import PricePerTraveller from '@/components/PricePerTraveller';
import Price from '@/propTypes/Price';

const FlightCTA = React.memo(
  ({
    isSelected = false,
    priceDifference,
    onSelected,
    priceForAdult = false,
    hidePerPersonPrice = false,
  }) => {
    return (
      <Flex flex={1} alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          {!hidePerPersonPrice && !isSelected && (
            <PricePerTraveller
              perTraveller={priceDifference}
              signedPrice
              priceForAdult={priceForAdult}
              hidePerPersonPrice={hidePerPersonPrice}
            />
          )}
        </Flex>
        {!isSelected && (
          <Flex alignItems="center" ml="6">
            <Button
              data-testid="FLIGHT_SELECT_BUTTON"
              onClick={(event) => {
                event.preventDefault();
                onSelected();
              }}
              nowrap
              variant="flight"
              width={['160px', null, '120px']}
            >
              Select flight
            </Button>
          </Flex>
        )}
      </Flex>
    );
  },
);

FlightCTA.propTypes = {
  isSelected: PropTypes.bool,
  priceDifference: PropTypes.shape(Price).isRequired,
  onSelected: PropTypes.func.isRequired,
  priceForAdult: PropTypes.bool,
  hidePerPersonPrice: PropTypes.bool,
};

export default FlightCTA;
